import { styled } from '@mui/material';

import { Button } from '~/components/ui/button';
import { Text } from '~/components/ui/text';
import { DESKTOP_MIN_WIDTH } from '~/constants/common';

import backgroundImg from './assets/background.webp';

export const StyledContainer = styled('div')(({ theme }) => ({
  width: '100%',
  borderRadius: '20px',
  backgroundImage: `url(${backgroundImg})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  display: 'flex',
  gap: '60px',
  padding: '40px',
  marginTop: '20px',
  marginBottom: '100px',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    flexDirection: 'column-reverse',
    alignItems: 'center',
    paddingInline: '8px',
    gap: '30px',
    marginBottom: '20px',
  },
}));

export const StyledImage = styled('img')(({ theme }) => ({
  flex: 1,
  maxWidth: '482px',
  height: 'fit-content',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    maxWidth: '50%',
  },
}));

export const StyledTextBlock = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '56px',
  flex: 1,
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    gap: '30px',
    alignItems: 'center',
  },
}));

export const StyledText = styled(Text)(({ theme }) => ({
  letterSpacing: '0',
  [theme.breakpoints.down(DESKTOP_MIN_WIDTH)]: {
    textAlign: 'center',
  },
}));

export const StyledTextWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  marginTop: '13px',
  gap: '16px',
}));

export const StyledCreateButton = styled(Button)(() => ({
  width: 'fit-content',
}));
